export class Crafts {
  Data: Craft[];
  Count: number;
}

export class Craft {
  Id?: number;
  Uid?: string;
  SUid?: string;
  Name1?: string;
  Name2?: string;

  constructor(craft: Craft = emptyCraft) {
    this.Id = craft.Id;
    this.Uid = craft.Uid;
    this.SUid = craft.SUid;
    this.Name1 = craft.Name1;
    this.Name2 = craft.Name2;
  }
}

const emptyCraft: Craft = {
  Id: 0,
  Uid: null,
  SUid: null,
  Name1: null,
  Name2: null
};
